import ImageryLayer from "@arcgis/core/layers/ImageryLayer"
import { IMAGERY_DATA } from "../imagery/constants"
import ImageryTileLayer from "@arcgis/core/layers/ImageryTileLayer"



let layers: Record<string, __esri.ImageryLayer | __esri.ImageryTileLayer> = {}


export const initImageryLayers = (map: __esri.Map, view: __esri.MapView): void => {
  IMAGERY_DATA.forEach((item) => {
    const layer = item.type === 'ImageryLayer' ? new ImageryLayer({ url: item.url }) : new ImageryTileLayer({ url: item.url })
    layer.visible = false
    map.add(layer)
    layers[item.label] = layer
  })
}

export const getImageryLayer = (key: string): __esri.ImageryLayer | __esri.ImageryTileLayer | null => layers && layers[key]